import { MdDelete } from "react-icons/md";
import CustomModal from "./customModal";
import { toast } from "react-toastify";

export const DeleteModal = ({
    isOpen,
    handleClose,
    fetchAllData,
    data,
    title = "Delete Item", // Default title
    deleteApiFunction, // Custom delete function to make it reusable
    entityName = "item", // Default entity name
  }) => {
    const handleDelete = async () => {
      // console.log("data", data);
      try {
        const res = await deleteApiFunction(data?._id); // Use the provided delete function
        // console.log("res", res);
        toast.success(`Deleted ${entityName} successfully`);
        handleClose();
        fetchAllData();
      } catch (err) {
        // console.log(err);
      }
    };
  
    return (
      <CustomModal isOpen={isOpen} onClose={handleClose} title={title}>
        <div className="flex flex-col gap-5 justify-center items-center">
          <MdDelete className="text-4xl text-red-700" />
          <p className="text-base">
            Are you sure you want to delete this {entityName}?
          </p>
          <div className="flex gap-10 justify-between">
            <button
              type="button"
              onClick={handleClose}
              className="bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-300"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-red-700 text-white px-4 py-2 rounded hover:bg-red-600"
              onClick={handleDelete}
            >
              Delete
            </button>
          </div>
        </div>
      </CustomModal>
    );
  };
  